<h2 mat-dialog-title>
  <mat-icon>inventory</mat-icon>
  Paquetes de servicio — {{ contractData.name }}
</h2>

<mat-dialog-content class="packages-dialog">
  <div class="panes">

    <!-- ── Lista de paquetes ─────────────────────────────────────────── -->
    <div class="pane pane--list">
      <div class="pane__head">
        <h3>Paquetes del contrato</h3>
        @if (permissions['create']) {
          <button mat-stroked-button (click)="newPackage()"><mat-icon>add</mat-icon>Nuevo</button>
        }
      </div>

      @if (packagesList.length === 0) {
        <p class="empty">Este contrato todavía no tiene paquetes.</p>
      }

      @for (pkg of packagesList; track pkg.id) {
        <div class="pkg-row" [class.pkg-row--active]="selectedPackage?.id === pkg.id" (click)="editPackage(pkg)">
          <div class="pkg-row__main">
            <b>{{ pkg.name }}</b>
            <span class="pkg-row__meta">{{ pkg.code || '—' }} · {{ itemsOf(pkg) }} partidas · {{ procedureName(pkg.procedure) }}</span>
          </div>
          @if (pkg.active === false) { <span class="pkg-row__inactive">Inactivo</span> }
          @if (permissions['delete']) {
            <button mat-icon-button color="warn" matTooltip="Quitar" (click)="$event.stopPropagation(); deletePackage(pkg)">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      }
    </div>

    <!-- ── Editor ────────────────────────────────────────────────────── -->
    <div class="pane pane--editor">
      @if (selectedPackage === null) {
        <p class="empty">Selecciona un paquete o crea uno nuevo.</p>
      } @else {
        <form [formGroup]="packageForm" class="pkg-form">
          <mat-form-field><mat-label>Nombre</mat-label><input matInput formControlName="name"></mat-form-field>
          <mat-form-field><mat-label>Código</mat-label><input matInput formControlName="code"></mat-form-field>
          <mat-form-field>
            <mat-label>Procedimiento</mat-label>
            <mat-select formControlName="procedure">
              <mat-option [value]="null">—</mat-option>
              @for (proc of procedureList; track proc.id) { <mat-option [value]="proc.id">{{ proc.name }}</mat-option> }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="wide"><mat-label>Descripción</mat-label><input matInput formControlName="description"></mat-form-field>
          <mat-slide-toggle formControlName="active">Activo</mat-slide-toggle>
        </form>

        <div class="items">
          <div class="items__add">
            <mat-form-field class="wide">
              <mat-label>Buscar insumo del contrato (código o descripción)</mat-label>
              <input matInput [(ngModel)]="productFilter" [ngModelOptions]="{standalone: true}">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            @if (productFilter.trim()) {
              <div class="items__results">
                @for (prod of filteredProducts; track prod.id) {
                  <button mat-menu-item (click)="addItem(prod)">
                    <b>{{ prod.code }}</b>&nbsp;{{ prod.description }}
                  </button>
                }
              </div>
            }
          </div>

          <table class="items__table">
            <tr><th>Código</th><th>Descripción</th><th class="num">Cantidad</th><th>Opcional</th><th></th></tr>
            @for (item of items; track $index) {
              <tr>
                <td>{{ item.code }}</td>
                <td>{{ item.description }}</td>
                <td class="num"><input type="number" min="1" [(ngModel)]="item.quantity" [ngModelOptions]="{standalone: true}" class="qty"></td>
                <td><mat-checkbox [(ngModel)]="item.optional" [ngModelOptions]="{standalone: true}"></mat-checkbox></td>
                <td><button mat-icon-button color="warn" (click)="removeItem($index)"><mat-icon>close</mat-icon></button></td>
              </tr>
            }
          </table>
          @if (items.length === 0) { <p class="empty">Sin partidas. Busca un insumo y agrégalo.</p> }
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
  @if (selectedPackage !== null && (permissions['create'] || permissions['update'])) {
    <button mat-raised-button color="accent" (click)="savePackage()"><mat-icon>save</mat-icon>Guardar paquete</button>
  }
</mat-dialog-actions>
